<template>
  <WhiteIQOS
    :title="$t('order_status_notification.title')"
    :subtitle="$t('order_status_notification.subtitle')"
    :enabled="edit_fields.enabled"
    bodyClass="gap-row-xs"
  >
    <div class="gap-row-2xs">
      <BaseCheckbox :class="{
        bold: edit_fields.channel_push
      }" v-model="edit_fields.channel_push"> 
        {{ $t('order_status_notification.push_title') }}
      </BaseCheckbox>
      <div class="v1-grey-7-color qrw-paragraph-md">
        {{ $t('order_status_notification.push_desc') }}
      </div>
    </div>

    <BaseDivider color="v1-grey-4"/>

    <div class="gap-row-2xs">
      <BaseCheckbox :class="{
        bold: edit_fields.channel_sms
      }" v-model="edit_fields.channel_sms"> 
        {{ $t('order_status_notification.sms_title') }}
      </BaseCheckbox>
      <div class="v1-grey-7-color qrw-paragraph-md">
        {{ $t('order_status_notification.sms_desc') }}
      </div>
    </div>

    <template #actions>
      <IQOSToggle v-model="edit_fields.enabled" />
    </template>
  </WhiteIQOS>
</template>

<script>
import WhiteIQOS from "@/components/base/WhiteIQOS.vue";

export default {
  components: {
    WhiteIQOS,
  },
  data() {
    return {
      edit_fields: {
        enabled: true,
        channel_push: false,
        channel_sms: false,
      },
    };
  },
  watch: {
    edit_fields: {
      deep: true,
      handler() {
        this.save();
      }
    }
  },
  methods: {
    save() {
      this.$store.commit("setClientAppData", {
        key: "notifications",
        value: this.edit_fields,
      });
      this.$store.dispatch("saveCafe");
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.edit_fields = {
      ...this.cafe.client_app.notifications,
    };
  },
};
</script>

<style>
</style>